export const getServiceRequestApprovals = (state) =>
  state.serviceRequestApprovals.results;